/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CascadeDeleteContentAccessRoleResponseDto } from '../models';
// @ts-ignore
import { ContentAccessRoleEntity } from '../models';
// @ts-ignore
import { CreateContentAccessRoleDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { UpdateContentAccessRoleDto } from '../models';
/**
 * ContentAccessRoleApi - axios parameter creator
 * @export
 */
export const ContentAccessRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cascade delete a content access role and remove it from users
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cascadeDeleteContentAccessRole: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cascadeDeleteContentAccessRole', 'id', id)
            const localVarPath = `/api/v1.0/content-access-roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new content access role
         * @param {CreateContentAccessRoleDto} createContentAccessRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContentAccessRole: async (createContentAccessRoleDto: CreateContentAccessRoleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContentAccessRoleDto' is not null or undefined
            assertParamExists('createContentAccessRole', 'createContentAccessRoleDto', createContentAccessRoleDto)
            const localVarPath = `/api/v1.0/content-access-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentAccessRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all content access roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContentAccessRoles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/content-access-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get content access role by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentAccessRoleById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContentAccessRoleById', 'id', id)
            const localVarPath = `/api/v1.0/content-access-roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a content access role
         * @param {string} id 
         * @param {UpdateContentAccessRoleDto} updateContentAccessRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentAccessRole: async (id: string, updateContentAccessRoleDto: UpdateContentAccessRoleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContentAccessRole', 'id', id)
            // verify required parameter 'updateContentAccessRoleDto' is not null or undefined
            assertParamExists('updateContentAccessRole', 'updateContentAccessRoleDto', updateContentAccessRoleDto)
            const localVarPath = `/api/v1.0/content-access-roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContentAccessRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentAccessRoleApi - functional programming interface
 * @export
 */
export const ContentAccessRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentAccessRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cascade delete a content access role and remove it from users
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cascadeDeleteContentAccessRole(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CascadeDeleteContentAccessRoleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cascadeDeleteContentAccessRole(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new content access role
         * @param {CreateContentAccessRoleDto} createContentAccessRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContentAccessRole(createContentAccessRoleDto: CreateContentAccessRoleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentAccessRoleEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContentAccessRole(createContentAccessRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all content access roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContentAccessRoles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContentAccessRoleEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContentAccessRoles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get content access role by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentAccessRoleById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentAccessRoleEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContentAccessRoleById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a content access role
         * @param {string} id 
         * @param {UpdateContentAccessRoleDto} updateContentAccessRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContentAccessRole(id: string, updateContentAccessRoleDto: UpdateContentAccessRoleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentAccessRoleEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContentAccessRole(id, updateContentAccessRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentAccessRoleApi - factory interface
 * @export
 */
export const ContentAccessRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentAccessRoleApiFp(configuration)
    return {
        /**
         * 
         * @summary Cascade delete a content access role and remove it from users
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cascadeDeleteContentAccessRole(id: string, options?: any): AxiosPromise<CascadeDeleteContentAccessRoleResponseDto> {
            return localVarFp.cascadeDeleteContentAccessRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new content access role
         * @param {CreateContentAccessRoleDto} createContentAccessRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContentAccessRole(createContentAccessRoleDto: CreateContentAccessRoleDto, options?: any): AxiosPromise<ContentAccessRoleEntity> {
            return localVarFp.createContentAccessRole(createContentAccessRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all content access roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContentAccessRoles(options?: any): AxiosPromise<Array<ContentAccessRoleEntity>> {
            return localVarFp.getAllContentAccessRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get content access role by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentAccessRoleById(id: string, options?: any): AxiosPromise<ContentAccessRoleEntity> {
            return localVarFp.getContentAccessRoleById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a content access role
         * @param {string} id 
         * @param {UpdateContentAccessRoleDto} updateContentAccessRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentAccessRole(id: string, updateContentAccessRoleDto: UpdateContentAccessRoleDto, options?: any): AxiosPromise<ContentAccessRoleEntity> {
            return localVarFp.updateContentAccessRole(id, updateContentAccessRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cascadeDeleteContentAccessRole operation in ContentAccessRoleApi.
 * @export
 * @interface ContentAccessRoleApiCascadeDeleteContentAccessRoleRequest
 */
export interface ContentAccessRoleApiCascadeDeleteContentAccessRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof ContentAccessRoleApiCascadeDeleteContentAccessRole
     */
    readonly id: string
}

/**
 * Request parameters for createContentAccessRole operation in ContentAccessRoleApi.
 * @export
 * @interface ContentAccessRoleApiCreateContentAccessRoleRequest
 */
export interface ContentAccessRoleApiCreateContentAccessRoleRequest {
    /**
     * 
     * @type {CreateContentAccessRoleDto}
     * @memberof ContentAccessRoleApiCreateContentAccessRole
     */
    readonly createContentAccessRoleDto: CreateContentAccessRoleDto
}

/**
 * Request parameters for getContentAccessRoleById operation in ContentAccessRoleApi.
 * @export
 * @interface ContentAccessRoleApiGetContentAccessRoleByIdRequest
 */
export interface ContentAccessRoleApiGetContentAccessRoleByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ContentAccessRoleApiGetContentAccessRoleById
     */
    readonly id: string
}

/**
 * Request parameters for updateContentAccessRole operation in ContentAccessRoleApi.
 * @export
 * @interface ContentAccessRoleApiUpdateContentAccessRoleRequest
 */
export interface ContentAccessRoleApiUpdateContentAccessRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof ContentAccessRoleApiUpdateContentAccessRole
     */
    readonly id: string

    /**
     * 
     * @type {UpdateContentAccessRoleDto}
     * @memberof ContentAccessRoleApiUpdateContentAccessRole
     */
    readonly updateContentAccessRoleDto: UpdateContentAccessRoleDto
}

/**
 * ContentAccessRoleApi - object-oriented interface
 * @export
 * @class ContentAccessRoleApi
 * @extends {BaseAPI}
 */
export class ContentAccessRoleApi extends BaseAPI {
    /**
     * 
     * @summary Cascade delete a content access role and remove it from users
     * @param {ContentAccessRoleApiCascadeDeleteContentAccessRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentAccessRoleApi
     */
    public cascadeDeleteContentAccessRole(requestParameters: ContentAccessRoleApiCascadeDeleteContentAccessRoleRequest, options?: AxiosRequestConfig) {
        return ContentAccessRoleApiFp(this.configuration).cascadeDeleteContentAccessRole(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new content access role
     * @param {ContentAccessRoleApiCreateContentAccessRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentAccessRoleApi
     */
    public createContentAccessRole(requestParameters: ContentAccessRoleApiCreateContentAccessRoleRequest, options?: AxiosRequestConfig) {
        return ContentAccessRoleApiFp(this.configuration).createContentAccessRole(requestParameters.createContentAccessRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all content access roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentAccessRoleApi
     */
    public getAllContentAccessRoles(options?: AxiosRequestConfig) {
        return ContentAccessRoleApiFp(this.configuration).getAllContentAccessRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get content access role by ID
     * @param {ContentAccessRoleApiGetContentAccessRoleByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentAccessRoleApi
     */
    public getContentAccessRoleById(requestParameters: ContentAccessRoleApiGetContentAccessRoleByIdRequest, options?: AxiosRequestConfig) {
        return ContentAccessRoleApiFp(this.configuration).getContentAccessRoleById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a content access role
     * @param {ContentAccessRoleApiUpdateContentAccessRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentAccessRoleApi
     */
    public updateContentAccessRole(requestParameters: ContentAccessRoleApiUpdateContentAccessRoleRequest, options?: AxiosRequestConfig) {
        return ContentAccessRoleApiFp(this.configuration).updateContentAccessRole(requestParameters.id, requestParameters.updateContentAccessRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}
